export const mapCraft = (craft) => {
  // const moreResources = craft.resources.filter(resource => resource.id !== craft.entry.id)
  return {
    collections: craft.collections,
    insightsFor: craft.insightsFor,
    socialImpacts: craft.socialImpacts,
    authors: craft.authors || [],
  };
};
